import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { Input, message, Modal, Select, theme } from "antd";

import { DatePicker } from "antd";
import { useCreateFinancialYear } from "../utils/queryUtils";
import { useDispatch, useSelector } from "react-redux";
import { setReloadFinancialYear } from "../store/action/reload";
import { financialYearTypes, periodTypes } from '../consts';

export default function AddFy({ client_id, returnSelected = () => { }, canSubmit = true, years }) {
	const [modal1Open, setModal1Open] = useState(false);
	const [, setLoading] = useState(false);
	const [selected, setSelected] = useState("");
	const { token: { colorPrimary } } = theme.useToken();
	const [data, setData] = useState({});
	let dateRef = useRef();
	const { company } = useSelector(st => st.selected);


	const { mutateAsync: createFinancialYear } = useCreateFinancialYear()
	const dispatch = useDispatch();

	useEffect(() => {
		if (!modal1Open) {
			setData({});
		}
	}, [modal1Open])

	async function submit(e) {
		try {
			let end = `${dayjs(selected).format("YYYY")}`
			let start = `${dayjs(selected).subtract(1, 'year').format("YYYY")}`;
			if (data.fy_type === "Other") {
				data.fy_type = data.custom_fy_type;
			}

			setLoading(true);
			let body = {};
			body = {
				client_id: client_id,
				end: end,
				start: start,
				company: company,
				fy_type: data.fy_type,
				period_type: data.period_type
				// company: all.company._id
			};
			const response = await createFinancialYear(body)
			if (response.success) {
				dispatch(setReloadFinancialYear(true));
				message.success("Fy is created")
			}
			setData({});
			setModal1Open(false);
		}
		catch (err) {
			message.error(err?.response?.data?.message || err?.response?.data?.errors[0]?.msg || "Failed to create entity");
			console.error(err)
		}
	}

	const openModel = (e) => {
		setSelected(e);
		if (canSubmit)
			setModal1Open(true);
		else returnSelected(dayjs(e).format("YYYY"));
	};

	return (

		<>

			<style jsx="true">{`
	  .fyyeaR .ant-picker-input > input::placeholder {
		color:#1677ff; 
		color: ${colorPrimary}; 
	  }
	`}</style>
			<DatePicker

				className="fyyeaR"
				placeholder="+ Add Fy"
				picker={"year"}
				suffixIcon=""
				variant="borderless"
				value={""}
				ref={dateRef}
				type="primary"
				onChange={openModel}
			/>

			<Modal
				title="Are you sure ?"
				centered
				open={modal1Open}
				onOk={submit}
				onCancel={() => setModal1Open(false)}
			>
				<label>Financial Year Type</label>
				<Select
					className="mb-2"
					style={{ width: '100%' }}
					placeholder="Select Financial Year Type"
					value={data.fy_type}
					onChange={(value) => setData((prev) => ({ ...prev, fy_type: value, custom_fy_type: '' }))}
				>
					{financialYearTypes.map((type, i) => (
						<Select.Option key={`financial-year-type-${i}`} value={type}>
							{type}
						</Select.Option>
					))}
				</Select>
				{data.fy_type === 'Other' && (
					<>
						<Input
							className="mb-3"
							placeholder="Enter your financial year type"
							value={data.custom_fy_type}
							onChange={(e) => setData((prev) => ({ ...prev, custom_fy_type: e.target.value }))}
						/>
					</>
				)}
				<label>Period Type</label>
				<Select
					className="mb-2"
					style={{ width: '100%' }}
					placeholder="Select Period Type"
					value={data.period_type}
					onChange={(value) => setData((prev) => ({ ...prev, period_type: value }))}
				>
					{periodTypes.map((type) => (
						<Select.Option key={type} value={type}>
							{type}
						</Select.Option>
					))}
				</Select>
				<p>
					Are you sure you want to add
					<span style={{ fontWeight: "bold", margin: "8px" }}>
						{dayjs(selected).format("YYYY") - 1} - {" "}
						{dayjs(selected).format("YY")}
					</span>
					financial year ?
				</p>
			</Modal>
		</>
	);
}
